import React from 'react';
import InvestorSecondaryMarketBannerSC from './investor-secondary-market-banner.styled';
import { HeadingTwo } from '../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';

const InvestorSecondaryMarketBanner = () => {
  return (
    <InvestorSecondaryMarketBannerSC>
      <div className="left-wrap">
        <HeadingTwo className="white left-wrap--main-headline">
          <FormattedMessage
            id="menu_secondary_market"
            defaultMessage={dlt['menu_secondary_market']}
          />
        </HeadingTwo>
      </div>
    </InvestorSecondaryMarketBannerSC>
  );
};

export default InvestorSecondaryMarketBanner;
